import { ProjectHoursBillingBy } from '@work4all/models/lib/Enums/ProjectHoursBillingBy.enum';

export const KEY_NAME_BY_BILLING_BY = {
  [ProjectHoursBillingBy.CUSTOMER]: 'customerCodes',
  [ProjectHoursBillingBy.ORDER_CONFIRMATION]: 'orderConfirmationCodes',
};
